import { trackEvent } from '~/utils/tracking'
import { Button } from '~/components/general/Button'
import { createOptimizedContentfulImage, getContentfulAsset } from '~/libs/contentful/helpers'
import { FlexContainer } from '~/components/Grid'
import { TypeHomePageBlock } from '~/types/contentful'
import { AssetFile } from 'contentful'

type CoverLetterProps = {
  section: TypeHomePageBlock<'WITHOUT_UNRESOLVABLE_LINKS', string>
}

export const CoverLetter = ({ section }: CoverLetterProps) => {
  const data = section.fields

  const handleCTABtnClick = () => {
    trackEvent('homepage_click_cta', {
      block: data.blockId,
      target: data.buttonLink as string,
      homepage_CTA: data.buttonName as string,
    })
  }

  const image = getContentfulAsset(data.images && data.images[0])

  return (
    <>
      <section
        className="my-25 -mx-8 max-xl:px-11 max-lg:my-15 max-lg:-mx-6 max-md:px-4 max-md:my-0 max-md:-mx-5"
        data-block-id={data.blockId}
      >
        <FlexContainer
          className="max-md:flex max-md:flex-col max-lg:gap-8 max-md:gap-4 max-md:flex-nowrap flex-wrap gap-16 min-h-[545px] max-xl:min-h-[433px] max-lg:min-h-[353px] max-md:min-h-auto"
          justify={'start'}
        >
          <div
            className="relative overflow-hidden max-md:basis-full rounded-3xl bg-neutral-5"
            style={{ flexBasis: '48.7%' }}
          >
            <img
              className="absolute left-0 top-0 w-full h-full object-cover hover:scale-105 max-lg:relative duration-300 ease transition-transform"
              src={
                data.images
                  ? createOptimizedContentfulImage({ file: image?.fields.file as AssetFile })
                  : ''
              }
              alt={data.images ? image?.fields.title : ''}
              loading="lazy"
            />
          </div>
          <FlexContainer
            justify={'start'}
            flexWrap={'nowrap'}
            className="max-lg:self-center max-md:margin-[unset] max-md:max-w-full relative justify-between flex-col gap-0 items-start my-auto mx-0 max-w-[450px] max-lg:max-w-[45%]"
          >
            <h2 className="text-l mb-6 max-w-[350px]">{data.title}</h2>
            <p className="text-s mb-9 max-md:hidden">{data.description}</p>
            <Button
              text={data.buttonName}
              type={'link'}
              href={data.buttonLink}
              onClick={handleCTABtnClick}
              className={'w-fit'}
            />
          </FlexContainer>
        </FlexContainer>
      </section>
    </>
  )
}
